import { AdvertisementSignUpForm } from 'components/Forms';
import { DashboardTitle } from 'components/Titles';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { advertisementSignUpValidation } from 'schemas';
import { AdvertisementService, PartnerService } from 'services';

import { Grid } from '@mui/material';

export const AdvertisementEdit = () => {
  const history: any = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [partners, setPartners] = useState({});

  useEffect(() => {
    getPartners();
  }, []);

  const getPartners = () => {
    PartnerService.getAllPartners()
      .then((response) => {
        const options: any = {};
        response?.data?.list?.forEach((partner: any) => {
          options[partner._id] = partner.socialReason;
        });
        setPartners(options);
      })
      .catch(() => {
        setSuccess('');
        setError('Não foi possível listar os parceiros');
      });
  };

  const { advertisement } = history.location.state;

  const initialValues = {
    title: advertisement?.title,
    image: advertisement?.image,
    url: advertisement?.url,
    partner: advertisement.partner?._id,
    active: advertisement?.active,
  };

  const handleSubmit = async (values: any) => {
    const isValid = await advertisementSignUpValidation.isValid(values);
    
    if (isValid) {
      setLoading(true);
      AdvertisementService.createUpdateAdvertisement(
        {
          title: values.title,
          image: values.image,
          url: values.url,
          partner: values.partner,
          active: values.active,
        },
        advertisement._id
      ).then(
        () => {
          setError('');
          setSuccess('Anúncio atualizado com sucesso');
        },
        ({ response }) => {
          setSuccess('');
          setError(response.data.error);
        }
      ).finally(
        () => {
          setLoading(false);
        }
      );
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="EDITAR ANÚNCIO" />
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={advertisementSignUpValidation}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <AdvertisementSignUpForm
              loading={loading}
              success={success}
              error={error}
              update
              partners={partners}
              bannerName={values?.image?.name}
              bannerUrl={values?.image?.url}
              active={values?.active}
            />
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};

